import { makeStyles } from '@material-ui/core/styles';
import { useContext, useState, useEffect } from 'react';
import { Box, Dialog } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Badge from '@mui/material/Badge';
import { useLocation } from 'react-router-dom';
//Iconos Barra Superior
import NotificationsNoneOutlinedIcon from '@material-ui/icons/NotificationsNoneOutlined';
import UserContext from '../../context/UserContext';
//Servicios
import { getNotificationsNumber } from '../../services/notifications';
//COmponentes
import CardNotification from './CardNotification';
import NotificationContent from './NotificationContent';
import useCheckPlan from '../../hooks/useCheckPlan';
import ComplianceModal from '../ComplianceModal/ComplianceModal';
import MessageContext from '../../context/MessageContext';
import { getPaymentCompliance } from '../../services/payments';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '@media (max-width: 1100px)': {
      width: 'auto',
    },
  },
  icon: {
    display: 'flex',
    justifyContent: 'center',
    '@media (max-width: 1100px)': {
      marginRight: 0,
    },
  },
}));

const NotificationIconComponent = ({ clean, handleLogout }) => {
  const { plan } = useContext(UserContext);
  const { addMessage, removeMessage } = useContext(MessageContext);
  const { setIncomingPlan } = useCheckPlan();
  const [numberNotification, setNumberNotification] = useState(0);
  const [resNotificationsPending, setResNotificationsPending] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [intervalTime, setIntervalTime] = useState(300000);
  const [openModalNotificationContent, setOpenModalNotificationContent] =
    useState(false);
  const [notificationSelect, setNotificationSelect] = useState({});
  const [openComplianceModal, setOpenComplianceModal] = useState(false);
  const [complianceData, setComplianceData] = useState(null);
  const classes = useStyles();
  const location = useLocation();
  const PENDING_PAYMENT = 'Pendiente de Pago';

  useEffect(() => {
    let intervalId = {};
    if (plan?.info) {
      getcomplianceData();
      getNotification();
      intervalId = setInterval(getNotification, intervalTime);
    }
    return () => {
      // Limpia el intervalo cuando el componente se desmonta para evitar fugas de memoria
      setNumberNotification(0);
      clearInterval(intervalId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clean, plan, intervalTime]);

  useEffect(() => {
    if (
      location.pathname !== '/pagos' &&
      location.pathname !== '/compras' &&
      location.pathname !== '/configuracion-cuenta' &&
      !plan?.info?.excluido_de_pagos
    ) {
      if (
        resNotificationsPending?.downgrades_habilitados &&
        complianceData?.compliant === false
      ) {
        setOpenComplianceModal(true);
      } else if (
        complianceData?.compliant === false &&
        !resNotificationsPending?.downgrades_habilitados
      ) {
        setOpenComplianceModal(false);
        addMessage({
          id: 'downgrade',
          description: `Prestaciones excedidas`,
          severity: 'error',
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, resNotificationsPending, complianceData]);

  const getcomplianceData = async () => {
    const res = await getPaymentCompliance();
    setComplianceData(res?.data);
  };

  //NOTIFICATIONS
  const getNotification = async () => {
    try {
      let res = await getNotificationsNumber();
      setNumberNotification(res?.data?.not_read);
      setIncomingPlan(res?.data?.plan);
      let aux = res?.data;

      // aux.downgrades_habilitados = true
      setResNotificationsPending(aux);

      if (!plan?.info?.excluido_de_pagos) {
        if (
          location.pathname !== '/pagos' &&
          location.pathname !== '/compras' &&
          location.pathname !== '/configuracion-cuenta'
        ) {
          if (res?.data?.downgrade && res?.data?.downgrades_habilitados) {
            setOpenComplianceModal(res?.data?.downgrade);
          } else if (
            res?.data?.downgrade &&
            !res?.data?.downgrades_habilitados
          ) {
            setOpenComplianceModal(false);
            removeMessage('downgrade');
            if (complianceData?.pendientes?.length > 0) {
              addMessage({
                id: 'downgrade',
                description: `Prestaciones excedidas`,
                severity: 'error',
              });
            } else {
              addMessage({
                id: 'downgrade',
                description: `Suscripción vencida`,
                severity: 'error',
              });
            }
          }
        }

        if (res?.data?.estado_compra === PENDING_PAYMENT) {
          addMessage({
            id: 'pending_payment',
            description: 'Su compra está pendiente de pago',
            severity: 'warning',
          });
          setIntervalTime(40000);
        } else {
          setIntervalTime(300000);
        }
        const remainingDays = aux?.dias_restantes;

        if (aux?.en_tolerancia && aux?.dias_tolerancia_restantes >= 0) {
          if (aux?.dias_tolerancia_restantes === 0) {
            addMessage({
              id: 'remaining_days',
              description: `Tu suscripción vence hoy. Es necesario que renueves tu plan.`,
              severity: 'error',
            });
            return;
          } else {
            addMessage({
              id: 'remaining_days',
              description: `Tu suscripción venció, te quedan ${aux?.dias_tolerancia_restantes} días restantes para renovar tu plan.`,
              severity: 'error',
            });
          }
        } else if (remainingDays !== null && remainingDays >= 0) {
          if (remainingDays < 1) {
            addMessage({
              id: 'remaining_days',
              description: `A tu suscripción le queda menos de un día.`,
              severity: 'error',
            });
          }
          if (remainingDays <= 5) {
            addMessage({
              id: 'remaining_days',
              description: `Quedan ${remainingDays} días restantes en tu plan actual.`,
              severity: 'error',
            });
          } else if (remainingDays < 10) {
            addMessage({
              id: 'remaining_days',
              description: `Quedan ${remainingDays} días restantes en tu plan actual.`,
              severity: 'warning',
            });
          }
        } else {
          removeMessage('remaining_days');
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleClose = () => {
    setOpenModal(!openModal);
  };

  const handleCloseNotificationContent = notification => {
    if (notification?.id) {
      setNotificationSelect(notification);
    } else {
      setNotificationSelect({});
    }
    setOpenModalNotificationContent(!openModalNotificationContent);
  };

  return (
    <Box className={classes.root}>
      {/* <Dialog open={openComplianceModal}>
        <ComplianceModal
          handleClose={() => {
            setOpenComplianceModal(false);
            getNotification();
          }}
          validateIfDowngrade={() => getcomplianceData()}
          handleLogout={handleLogout}
          lastPurchase={resNotificationsPending?.last_compra}
          setOpenComplianceModal={setOpenComplianceModal}
          purchaseState={resNotificationsPending?.estado_compra}
        />
      </Dialog> */}

      {/* Modal de la notificacion contenido principal */}
      {notificationSelect?.id && (
        <NotificationContent
          notificationSelect={notificationSelect}
          openModalNotificationContent={openModalNotificationContent}
          handleCloseNotificationContent={handleCloseNotificationContent}
        />
      )}
      {/* NOTFICACIONES */}
      <Box className={classes.icon}>
        <Tooltip title="Notificaciones">
          <IconButton onClick={handleClose} color="primary">
            <Badge
              badgeContent={numberNotification}
              showZero={numberNotification > 0}
              color="secondary"
            >
              <NotificationsNoneOutlinedIcon />
            </Badge>
          </IconButton>
        </Tooltip>
      </Box>
      <CardNotification
        getNotification={getNotification}
        openModal={openModal}
        handleClose={handleClose}
        handleCloseNotificationContent={handleCloseNotificationContent}
        setNumberNotification={setNumberNotification}
      />
    </Box>
  );
};
export default NotificationIconComponent;
